// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vcjgzqjktnpdjeunnhme.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjamd6cWprdG5wZGpldW5uaG1lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczMzA2NDAsImV4cCI6MjA2MjkwNjY0MH0.kyuNizbKzj0iCPgbV-ufK5_Z0dlkoNotxbVUnBu4rF4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);